import { ContainerType } from '@apiContract';
import { WorkflowMail, WorkflowPackages } from '@rdTypes/contractHelpers';

export const getContainerTypeIdByWorkflow = (
  containerTypes: ContainerType[],
  workflow: WorkflowMail | WorkflowPackages,
): number => containerTypes.find((ct) => ct.workflow === workflow)?.id || 0;
